module.exports = __webpack_public_path__ + "media/state-press_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/state-press_1600.jpg
// module id = 49
// module chunks = 0